import React from 'react';
import {Button, ButtonGroup} from 'react-bootstrap';
import PlayFill from '@mui/icons-material/PlayArrowRounded';

const ConfigActionButtons = ({
  hasChanges,
  hasActiveConfig,
  isAnyConfigSelected,
  isSelectedConfigActive,
  onReset,
  onSave,
  onSaveAndActivate,
  onActivate,
}) => (
  <div className="float-end">
    <ButtonGroup>
      <Button variant="outline-primary" onClick={onReset} disabled={!hasChanges}>
        Reset
      </Button>
      <Button variant="outline-primary" onClick={onSave} disabled={!hasChanges || !hasActiveConfig}>
        Save
      </Button>
      {hasChanges || (!hasActiveConfig && !isAnyConfigSelected) ? (
        <Button className="button-accent" onClick={onSaveAndActivate}>Save &amp; Apply</Button>
      ) : !isSelectedConfigActive && hasActiveConfig && isAnyConfigSelected ? (
        <Button className="button-accent" onClick={onActivate}>
          <PlayFill fontSize="small"/> Activate
        </Button>
      ) : (
        <Button disabled>Save &amp; Apply</Button>
      )}
    </ButtonGroup>
  </div>
);

export default ConfigActionButtons;

